import $http from '../utils/http';

const uploadFile = (token, payload) => {
  const header = token ? { authorization: token, 'x-company-header': Cookies.get('companyID') } : null;
  return $http(`/upload`, payload, 'POST', header);
};

export { uploadFile };
